export const DVD_CASE_IMAGE = "/images/dvd-case-preview.webp";
